module.exports = __webpack_public_path__ + "bz.09219a89104599121888.svg";


//////////////////
// WEBPACK FOOTER
// D:/projects/feelway-pawnshop/pawnshop-web-client-feelway/src/assets/scss/icons/flag-icon-css/flags/bz.svg
// module id = ../../../../../src/assets/scss/icons/flag-icon-css/flags/bz.svg
// module chunks = styles